const REGISTRATION_BASE = '/registracion';
const EQUIPO_BASE = '/equipo';
const ARMA_EQUIPO_BASE = '/armado';
const MI_EQUIPO_BASE = '/mi-equipo';
const MI_CUENTA_BASE = '/mi-cuenta';
const EDITAR_DATOS = '/editar-cuenta';
const TORNEOS = '/torneos';
const MINILIGAS_BASE = '/miniligas';
const FECHA_ORO_BASE = '/fecha-de-oro';
const TORNEOS_AMIGOS_BASE = '/torneo-de-amigos';
const TORNEOS_AMIGOS_PREMIOS = '/torneo-de-amigos-por-premios';
const TORNEOS_ESCUELA_BASE = '/torneo-de-escuelas';
const COPA_AMIGOS_BASE = '/copa-de-amigos';
const DESAFIO_UNO_A_UNO_BASE = '/desafios';

const ARMADO_11 = `${ARMA_EQUIPO_BASE}/futbol-11`;
const TACTICA_ARMADO_11 = `${ARMADO_11}/editar/tactica`;

const ROUTES = {
  basePath: '/',
  notFound: '/404',
  summary: '/resumen',
  recentMatchStats: '/partidos-recientes',
  recoverEmail: '/recuperar-email',
  welcome: `/bienvenida`,
  welcomeF5: `/bienvenida-f5`,
  team: EQUIPO_BASE,
  myTeam: MI_EQUIPO_BASE,
  buildTeam: ARMA_EQUIPO_BASE,
  team11: `${EQUIPO_BASE}/futbol-11`,
  team5: `${EQUIPO_BASE}/futbol-5`,
  buildTeam11: ARMADO_11,
  buildTeam5: `${ARMA_EQUIPO_BASE}/futbol-5`,
  myTeam11: `${MI_EQUIPO_BASE}/futbol-11`,
  myTeam5: `${MI_EQUIPO_BASE}/futbol-5`,
  recommender: `/recomendador`,
  changeTactic: TACTICA_ARMADO_11,
  teamConfirm: `${ARMA_EQUIPO_BASE}/equipo-confimado`,
  teamConfirmF5: `${ARMA_EQUIPO_BASE}/equipo-confimado-f5`,
  registration: REGISTRATION_BASE,
  registrationSchool: `${REGISTRATION_BASE}/torneo-de-escuelas`,
  registrationNameTeam: `${REGISTRATION_BASE}/nombre-de-equipo`,
  myAccount: MI_CUENTA_BASE,
  myPins: '/mis-pines',
  movements: '/movimientos',
  premiumBenefits: `${MI_CUENTA_BASE}/beneficios-premium`,
  virtualCharges: `${MI_CUENTA_BASE}/kioscos`,
  paymentMethodSelection: `${MI_CUENTA_BASE}/metodo-pago`,
  selectPaymentCard: `${MI_CUENTA_BASE}/seleccionar-tarjeta`,
  paymentForm: `${MI_CUENTA_BASE}/pago`,
  tournaments: `${TORNEOS}`,
  friendsTournament: `${TORNEOS_AMIGOS_BASE}`,
  viewTourney: `${TORNEOS_AMIGOS_BASE}/ver`,
  adminTourney: `${TORNEOS_AMIGOS_BASE}/administrar`,
  createFriendsTournament: `${TORNEOS_AMIGOS_BASE}/crear`,
  reactivateFriendsTournament: `${TORNEOS_AMIGOS_BASE}/reactivar`,
  InviteToFriendsTournament: `${TORNEOS_AMIGOS_BASE}/invitar`,
  friendsTournamentsStadistics: `${TORNEOS_AMIGOS_BASE}/estadisticas`,
  friendsTournamentPrizes: `${TORNEOS}${TORNEOS_AMIGOS_PREMIOS}`,
  viewTapTourney: `${TORNEOS}${TORNEOS_AMIGOS_PREMIOS}/ver`,
  schoolTournament: `${TORNEOS_ESCUELA_BASE}`,
  primarySchoolTournament: `${TORNEOS_ESCUELA_BASE}/primaria`,
  friendsCup: {
    home: `${COPA_AMIGOS_BASE}`,
    createTeam: `${COPA_AMIGOS_BASE}/crear`,
    invite: `${COPA_AMIGOS_BASE}/invitar`,
    info: `${COPA_AMIGOS_BASE}/info`,
    viewTeam: `${COPA_AMIGOS_BASE}/ver`,
    adminTeam: `${COPA_AMIGOS_BASE}/administrar`,
  },
  minileagues: {
    home: `${MINILIGAS_BASE}`,
    create: `${MINILIGAS_BASE}/crear`,
    info: `${MINILIGAS_BASE}/info`,
    view: `${MINILIGAS_BASE}/ver`,
    admin: `${MINILIGAS_BASE}/administrar`,
    viewRival: `${MINILIGAS_BASE}/rival`,
    viewFinal: `${MINILIGAS_BASE}/final`,
    reactivate: `${MINILIGAS_BASE}/reactivar`,
    invite: `${MINILIGAS_BASE}/invitar`,
  },
  goldDate: {
    home: `${FECHA_ORO_BASE}`,
    list: `${FECHA_ORO_BASE}/listado`,
    ranking: `${FECHA_ORO_BASE}/ranking`,
    info: `${FECHA_ORO_BASE}/info`,
  },
  challenge: {
    home: `${DESAFIO_UNO_A_UNO_BASE}`,
    resultados: `${DESAFIO_UNO_A_UNO_BASE}/resultados`,
  },
  ranking: `/ranking`,
  medals: `/mis-medallas`,
  schoolsTournament: `/torneo-de-escuelas`,
  editAccount: {
    home: `${EDITAR_DATOS}`,
    menu: `${EDITAR_DATOS}/menu`,
    myTeam: `${EDITAR_DATOS}/mi-equipo`,
    tshirtPanel: `${EDITAR_DATOS}/mi-camiseta`,
    shieldPanel: `${EDITAR_DATOS}/mi-escudo`,
    myAwards: `${EDITAR_DATOS}/mis-diplomas`,
    myData: `${EDITAR_DATOS}/mis-datos-personales`,
    myCBU: `${EDITAR_DATOS}/mi-cbu`,
    myHistory: `${EDITAR_DATOS}/mis-campanas-anteriores`,
  },
  trivia: `/trivia`,
  preguntasFrecuentes: `/preguntas-frecuentes`,
  notifications: `/notificaciones`,
};

export default ROUTES;
